// import axios from 'axios'
import { post, put, get } from "@/api/api";

export const actions = {
  fetchAttributsExclures({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    let data =  get(`/canal/attributsExclure`)
    commit("addAttributsExclures", data);
    return data
  },
  async fetchAttributsExcluresPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
    }).toString();

    let { data } = await get(`/canal/attributsExclure?${queryParams}`);
    commit("addAttributsExcluresPage", data)
    return data;
  },
  createAttributsExclure({ commit }, attributsexclure) {
    return post("/canal/attributsExclure", attributsexclure).then(
      ({ data }) => {
        commit("addAttributsExclure", data);
      }
    );
  },
  updateAttributsExclure({ commit }, attributsexclure) {
    return put(
      `/canal/attributsExclure${attributsexclure.id}`,
      attributsexclure
    ).then(({ data }) => {
      commit("replaceAttributsExclure", data);
    });
  },
  createOrUpdateAttributsExclure({ dispatch }, attributsexclure) {
    if (attributsexclure.id !== undefined) {
      return dispatch("updateAttributsExclure", attributsexclure);
    } else {
      return dispatch("createAttributsExclure", attributsexclure);
    }
  },
  selectAttributsExclure({ commit }, attributsexclure) {
    commit("setAttributsExclure", attributsexclure);
  },
};
